import {nodeAddedMap} from './MutationHandler';
import {ensureShoelaceThemeLoaded, getShoelaceBaseUrl} from './utils';

const tagName = 'sl-icon';

export const IconController = Object.freeze({
  tagName,
  selector: tagName,
  moduleUrl: `${getShoelaceBaseUrl()}components/icon/icon.js`,
  async ensureLoaded() {
    return Promise.all([
      ensureShoelaceThemeLoaded(),
      import(/* webpackIgnore: true */ IconController.moduleUrl),
    ]);
  },
});

nodeAddedMap.set(IconController.selector, (target) => {
  if (!target.matches(IconController.selector)) {
    return;
  }

  if (!customElements.get(IconController.tagName)) {
    IconController.ensureLoaded();
  }
});
